export class AuthResult {
    constructor(
        public userId?: string,
        public id_token?: string,
        public access_token?: string,
        public refresh_token?: string,
        public expires_in?: number,
        public issued_date?: Date,
        public expiration_date?: Date) { }
}
